/* eslint-disable import/no-useless-path-segments */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useParams, Link } from 'react-router-dom';
import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
import {Grid} from '@material-ui/core';
import Button from '@mui/material/Button';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import styles from '../BookingStatus/BookingStatus.module.css'
import {CustomNameTab, CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { withAllowedOperationsProvider } from '../../hocs'
import Truckloading from "../../components/CvLoader/Cvloader";

import  TableSimple from '../../atomicComponents/TableSimple1/TableSimple';
import { setLogin } from '../../redux/features/auth/actions';
import apiService from '../../apis/apiService';


function AccessControlForm({ redirectToProcessPage, product, counter, baseUrl, auth }) {

  let { userRole, userID, personNumber, companyCode, persArea, apiSendData } = auth; // get user pers_no and manager details 


  const [approveFlag, setApproveFlag] = useState("")
  const { showPopup } = usePopupManager();
  const [loading, setLoading] = React.useState(false);
  const [mobile, setMobile] = useState(window.innerWidth <= 500)
  const [eDetails, setEDetails] = useState("");
  const [apiPayloadData, setAPIPaylodData] = useState(apiSendData);

  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth <= 500);
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const dispatchNew= useDispatch();
  const history = useHistory();

  const [myState, setState] = React.useState(
    {
      ticket_number: "",
      employeDetails:{},
      userRemark:"",
      bcHeadRemark:"",
      superAdminRemark:"",
      chassisNo: null,
      toDate: null,
      fromDate: null,
      bodyBuilder: null,
      checkFlag: false,
      checkBox:true

    });

    const [ticketNumber, setTicketNumber] = useState("")
    const {requestType, activeId} = useParams();
    const [disableTicketNumber, setDisableTicketNumber] = useState(false);

  useEffect(() => {
  const getRequestDetails = async() =>{
    setLoading(true)
    let apiFormatedData = {
        "request_id":activeId
    }
  try {
    const response = await apiService.GetAdditionalAccessRequestDetails(apiFormatedData)
    dispatchNew(setLogin({...auth, recentStatus: response.status}))
    if (response?.data) {
      if(response?.["msg"] === "Success"){
        setLoading(false)
        setState((prevData) => ({ ...prevData, ticket_number:response.data[0]["pers_no"],
          employeDetails: response.data[0],
          userRemark:response.data[0]["user_remark"],
          startDate:response.data[0]["effective_date"],
          endDate:response.data[0]["end_date"],
          bcHeadRemark:response.data[0]["bc_remark"],
          bcApprove: response.data[0]["bc_approval_status"],
          superAdminRemark:response.data[0]["admin_remark"],
          saApprove: response.data[0]["admin_approval_status"],

        }));
        setEDetails(response.data[0]["pers_no"].length)
      }
      else if(response?.["msg"]==="Fail"){
        setLoading(false)
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: response.msg,
        });
      }
      
  }
  } catch (error) {
    setLoading(false)
      console.info(error)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Oops! Something went wrong. Please try again later",

      });
  }
  }
  if(activeId){
  getRequestDetails()
}
},[activeId]);

  const RedirectToDashboard = () => {
    const reqtype = requestType.split("-").shift();
      if (reqtype == "PL" ) {
        dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData}));
        history.push("/linkage-dashboard");
      }
      else if(reqtype == "BS" || reqtype == "AA") {
        dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData}));
        history.push("/requestor-dashboard")
      }
  } 

    const mappingTable = () => (
      <div
        className={styles.formGroup}>
      { activeId &&
      <Grid
          container
          spacing={1}
          style={{ marginTop: "10px" }}
          // className={styles.myGrid}
          columns={12}
        >
            <Grid item md={8} lg={8} xs={8}/>
            <Grid item md={4} lg={4} xs={4}>
            <div className={styles.requestid}>
                  <div className={clsx(styles.lableDiv2)}>
                    <label style={{textAlign:"right"}}>Request ID: {activeId}</label>
                  </div>
              </div>
              </Grid>
        </Grid>}
        <Grid
          container
          spacing={1}
          // className={styles.myGrid}
          style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={2} lg={2} xs={2} sm={2}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv2)}>
                <label>Employee Details</label>
              </div>
            </div>
          </Grid>
          {loading==true ?
            <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"10px",background:"white", boxShadow:"0px 3px 6px #00000027"}}>
                <Truckloading />
              </div>
      : (
          <Grid item md={10} lg={10} xs={10} sm={10}>
                <TableSimple
                  tableColumnData={[
                    {
                      ticket: (activeId ? <div>{myState.ticket_number}</div>:
                        <ValidatingTextField
                          variant="outlined"
                          size="small"
                          isDisabled={activeId || disableTicketNumber}
                          value={myState.ticket_number}
                          onChange={onChangeHandler}
                          name="ticket_number"
                          inputProps={{
                            "data-testid": "remark-input",
                          }}
                          style={{ width: "100%" }}
                        />
                      ),
                      empName: myState.employeDetails["employee_name"] ?? "",
                      bcNo: myState.employeDetails["bc_no"] ?? "",
                      bcDesc: myState.employeDetails["costcenter_name"] ?? "",
                      workArea: myState.employeDetails["workarea"] ?? "",
                    },
                  ]}
                  tableHeaderLabel={[
                    "Ticket No_90",
                    "Employee Name",
                    "BC Number",
                    "BC Name",
                    "Work Area",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
          </Grid>
          )}
        </Grid>
      </div>
        )        
    const ApproverTable = () => (
      <div
        className={styles.formGroup}>
      <Grid
          container
          spacing={1}
          // className={styles.myGrid}
          // style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={2} lg={2} xs={2}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv2)}>
                <label>Approval Details :</label>
              </div>
            </div>
            </Grid>
            <Grid item md={10} lg={10} xs={10}>
                <TableSimple
                  tableColumnData={[
                    {
                      ticket: myState.employeDetails["bc_pers_no"],
                      empName: myState.employeDetails["bc_head_name"] ?? "",
                      bcNo: myState.employeDetails["bc_head_costcenter"] ?? "",
                      bcDesc: myState.employeDetails["bc_head_costcenter_name"] ?? "",
                      workArea: myState.employeDetails["bc_head_workarea"] ?? "",
                    },
                  ]}
                  tableHeaderLabel={[
                    "Ticket Number_70",
                    "Employee Name",
                    "BC Number",
                    "BC Name",
                    "Work Area",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
                </Grid>
        </Grid>
      </div>
        )           
    const renderbookingdetails = () => (
    <div
    className={styles.formGroup}>
    <Grid
        container
        spacing={1}
        // className={styles.myGrid}
        // style={{marginTop: "10px" }}
        columns={12}
        >
        <Grid item md={2} lg={2} xs={12}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
                <label>Booking Status Details:</label>
            </div>
        </div>
        </Grid>
        <Grid item md={3} lg={3} xs={12}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
                <label>Current Status</label>
            </div>
            <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["employee_bookable_status"] && myState.employeDetails.employee_bookable_status === "Y" ? "BOOKABLE" : "NON-BOOKABLE"}
                name="current_booking_status"
                isDisabled='true'
                inputProps={{
                    "data-testid": "remark-input",
                }}
                style={{ width: "50%" }}
                />
            </div>       
        </Grid>

        <Grid item md={3} lg={3} xs={12}>
            <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
                <label> Propose Status</label>
            </div>
            <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["proposed_status"] }
                name="proposed_status"
                isDisabled='true'
                inputProps={{
                    "data-testid": "remark-input",
                }}
                style={{ width: "50%" }}
                />
            </div>
        </Grid>
        <Grid item md={2} lg={2} xs={12}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
                <label>From</label>
            </div>
                <CustomDatePicker
                clearable
                disabled
                autoOk
                inputVariant="outlined"
                value={myState.startDate || null}
                inputProps={{
                    className: clsx(styles.select, styles.dateInput),
                }}
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%",marginLeft:"24px" }}
                />
            </div>
        </Grid>
        <Grid item md={2} lg={2} xs={12}>
            <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
                <label>To</label>
            </div>
                <CustomDatePicker
                isDisabled='true'
                disabled
                clearable
                autoOk
                inputVariant="outlined"
                value={myState.employeDetails.employee_bookable_status === "Y"?myState.endDate :null}
                inputProps={{
                    className: clsx(styles.select, styles.dateInput),
                }}
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%",marginLeft:"24px" }}
                />
                
            </div>
        </Grid>
        </Grid>
        </div>
        )

    const renderUserRemark = () => (
        <div className={styles.formGroup}>
        <Grid
        container
        spacing={1}
        style={{
            marginTop: "10px",
        }}
        // className={styles.myGrid}
        columns={12}
        >
        <Grid item md={2} lg={2} xs={2}>
            <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
                <label>User Remark :</label>
            </div>
            </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
            <ValidatingTextField
                variant="outlined"
                size="small"
                isDisabled='true'
                value={myState.userRemark}
                name="projectSearch"
                inputProps={{
                    "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
                />
        </Grid>
        </Grid>
        </div>
        )

    const renderSPOCRemark = () => (

        <div className={styles.formGroup}>

            <Grid
            container
            spacing={1}
            style={{
                marginTop: "10px",
            }}
            columns={12}
            >
            <Grid item md={2} lg={2} xs={2}>
                <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                <label>BC Head Remark :</label>
                </div>
                </div>
            </Grid>
            <Grid item md={10} lg={10} xs={10}>
                    <ValidatingTextField
                    variant="outlined"
                    size="small"
                    isDisabled='true'
                    value={myState.bcHeadRemark}
                    name="bcHeadRemark"
                    inputProps={{
                        "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                    />
            </Grid>
            </Grid>
        </div>
        )

    const renderSuperAdminRemark = () => (
        <div className={styles.formGroup}>
        <Grid
        container
        spacing={1}
        style={{
            marginTop: "10px",
        }}
        columns={12}
        >
        <Grid item md={2} lg={2} xs={2}>
            <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
            <label>Super Admin Remark :</label>
            </div>
            </div>
            </Grid>
        <Grid md={10} lg={10} xs={10}>
        <ValidatingTextField
            variant="outlined"
            size="small"
            isDisabled='true'
            value={myState.superAdminRemark}
            name="projectSearch"
            inputProps={{
            "data-testid": "remark-input",
            }}
            style={{ width: "100%", }}
        />
        </Grid>
        </Grid>
        </div>
        )

  return (
        <>
          <Grid container spacing={0}>
            <Grid item md={1} lg={1} xs={1} sm={1} style={{marginRight: '-35px'}}> 
                <ArrowCircleLeftIcon 
                  style={{
                    fontSize:'40px', 
                    color: "#608FC9", 
                    margin: '-4px 0px 1px 10px',
                    cursor: 'pointer'
                  }} 
                  onClick={() => RedirectToDashboard()}
                />
            </Grid>
            <Grid item md={11} lg={11} xs={9} sm={9}> 
              <CustomFormGroup
                header='Change Booking Status'
                // body={mappingTable()} 
                />
            </Grid>
          </Grid>

            {mappingTable()}
            {renderbookingdetails()}
            {ApproverTable()}
            {renderUserRemark()}
            {renderSPOCRemark()}
            {renderSuperAdminRemark()}
        </>
  ) 
}

AccessControlForm.propTypes = {
  redirectToProcessPage: PropTypes.func
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});

AccessControlForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps)(AccessControlForm);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);
